import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "btn-audio btn bg-light rounded border-0 text-secondary px-3 bg-opacity-05",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#AudioPlayerModulOffcanvas",
  "aria-controls": "AudioPlayerModulOffcanvas"
}

import { computed } from "vue";
import Equalizer from "../_shared/dividers/Equalizer.vue";
import IconComponent from "../_shared/icons/icon-component.vue";
import { useAudio } from "@/store/modules/media/audio-list";


export default /*@__PURE__*/_defineComponent({
  __name: 'btn-audio',
  setup(__props) {

const isPlaying = computed(() => useAudio().isPlaying);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createVNode(IconComponent, {
      lib: 'filoxenia',
      icon: 'MusicNote',
      class: "fs-3"
    }),
    _createVNode(Equalizer, { animation: isPlaying.value }, null, 8, ["animation"])
  ]))
}
}

})